import type { IconData } from '@stacksjs/iconify-core'

export const cloudOffFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 5.5q.429 0 .84.003c3.938.028 7.23 1.426 9.598 3.799c2.296 2.3 3.696 5.49 4 9.165C43.29 20.15 46.5 24.37 46.5 30c0 3.574-1.294 6.592-3.502 8.751c-2.206 2.157-5.296 3.429-8.848 3.57c-2.72.108-6.063.179-10.15.179s-7.43-.071-10.15-.18c-3.552-.14-6.642-1.413-8.848-3.569C2.794 36.592 1.5 33.574 1.5 30c0-5.631 3.21-9.85 8.062-11.533c.304-3.676 1.704-6.865 4-9.165c2.368-2.373 5.66-3.771 9.598-3.799q.411-.003.84-.003\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M2.982 4.232a2.5 2.5 0 0 1 3.536 0l38 38a2.5 2.5 0 0 1-3.536 3.536l-38-38a2.5 2.5 0 0 1 0-3.536\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cloudOffFlat
